<template>
    <FKBreadCrumb :page="$t('page.profile')" />
    <div class="row">
      <div class="col-12 col-lg-6 col-xxl-4">
        <ProfileAnagraph/>
      </div>
      <div class="col-12 col-lg-6 col-xxl-8">
        <ProfileCenters/>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
  import ProfileAnagraph from "@/components/FK/Profile/ProfileAnagraph.vue";
  import ProfileCenters from "@/components/FK/Profile/ProfileCenters.vue";
  
  export default defineComponent({
    name: "ProfilePage",
    components: {
      FKBreadCrumb,
      ProfileAnagraph,
      ProfileCenters
    },
  });
  </script>